module.exports = __webpack_public_path__ + "img/3.38d01f86.png";